export default [{
  locale: 'sme',
  pluralRuleFunction(e, t) {
    // eslint-disable-next-line no-nested-ternary,eqeqeq,yoda
    return t ? 'other' : 1 == e ? 'one' : 2 == e ? 'two' : 'other';
  },
  fields: {
    year: {
      displayName: 'Year',
      relative: { 0: 'this year', 1: 'next year', '-1': 'last year' },
      relativeTime: { future: { other: '+{0} y' }, past: { other: '-{0} y' } },
    },
    month: {
      displayName: 'Month',
      relative: { 0: 'this month', 1: 'next month', '-1': 'last month' },
      relativeTime: { future: { other: '+{0} m' }, past: { other: '-{0} m' } },
    },
    day: {
      displayName: 'Day',
      relative: { 0: 'today', 1: 'tomorrow', '-1': 'yesterday' },
      relativeTime: { future: { other: '+{0} d' }, past: { other: '-{0} d' } },
    },
    hour: {
      displayName: 'Hour',
      relativeTime: { future: { other: '+{0} h' }, past: { other: '-{0} h' } },
    },
    minute: {
      displayName: 'Minute',
      relativeTime: { future: { other: '+{0} min' }, past: { other: '-{0} min' } },
    },
    second: {
      displayName: 'Second',
      relative: { 0: 'now' },
      relativeTime: { future: { other: '+{0} s' }, past: { other: '-{0} s' } },
    },
  },
}];



/** WEBPACK FOOTER **
 ** ./app/locale-data/sme.js
 **/